import React, { useMemo } from 'react';
import styled from 'styled-components';

import { MatchEntityStatus } from '../../../../states/entities/matches';
import { type MatchStatus } from '../../../../types/match';
import { LineUpFinishFlags, LineUpGreenStartLights, LineUpRedStartLights } from '../../assets/svg';

const Wrapper = styled.div`
  position: relative;
`;

const StyledLineUpFinishFlags = styled(LineUpFinishFlags)`
  position: absolute;
  margin-top: -1em;
  width: 6em;
  overflow: visible;
`;

const StyledLineUpGreenStartLights = styled(LineUpGreenStartLights)`
  height: 100%;
  overflow: visible;
`;

const StyledLineUpRedStartLights = styled(LineUpRedStartLights)`
  height: 100%;
  overflow: visible;
`;

type LineUpRaceStatusIndicatorPropsType = {
  className?: string;
  matchStatus: MatchStatus;
};

const LineUpRaceStatusIndicator = ({ className = '', matchStatus }: LineUpRaceStatusIndicatorPropsType) => {
  const Component = useMemo(() => {
    if (MatchEntityStatus.isEnded(matchStatus)) {
      return StyledLineUpFinishFlags;
    }
    if (MatchEntityStatus.isLive(matchStatus)) {
      return StyledLineUpGreenStartLights;
    }
    return StyledLineUpRedStartLights;
  }, [matchStatus]);

  return (
    <Wrapper className={className}>
      <Component />
    </Wrapper>
  );
};

export default LineUpRaceStatusIndicator;
